module.exports = __webpack_public_path__ + "static/media/tex-trends-top10-fw2526.7aa07bbc.jpg";